import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {FacebookService, UIResponse} from 'ngx-facebook';

@Component({
  selector: 'app-share',
  templateUrl: './app-share.component.html',
  styleUrls: ['app-share.component.scss'],
  providers: []
})

export class AppShareComponent implements OnInit {

  @Input() type: string;
  @Input() id: string;
  @Input() title: string;

  constructor(private fb: FacebookService) {
  }

  ngOnInit() {
  }

  public share(platform) {
    let share_link;
    switch (platform) {
      case 'linkedin':
        share_link = 'https://www.linkedin.com/shareArticle?mini=true&url=https%3A//tutored.me/p/' +
          this.type + '/753&title=' + this.title +
          '&summary=&source=';
        window.open(share_link, 'Share via Linkedin', 'width=400,height=400');
        break;
      case 'twitter':
        share_link = 'https://twitter.com/home?status=' + this.title + '%0Ahttps%3A//tutored.me/' + this.type + '/' + this.id;
        window.open(share_link, 'Share via Twitter', 'width=400,height=400');
        break;
      default:
        share_link = 'https://tutored.me/p/' + this.type + '/' + this.id;
        this.fb.ui({
          method: 'share',
          href: share_link,
        })
          .then((res: UIResponse) => console.log(res))
          .catch((e: any) => console.error(e));
        break;
    }
  }

}
